/* kb-cart-goal.js */
(function(){
  'use strict';

  // Doppelt laden verhindern
  if (window.KB_CART_GOAL_INIT) return;
  window.KB_CART_GOAL_INIT = true;

  var SEL = '.kb-goal';

  function readTiersFromHTML(el){
    var nodes = el.querySelectorAll('.kb-goal__tier');
    var out = [];
    nodes.forEach(function(n){
      var qty = parseInt(n.getAttribute('data-qty') || '0', 10);
      var labelEl = n.querySelector('.kb-goal__tier-label');
      var label = labelEl ? labelEl.textContent.trim() : '';
      if (qty > 0 && label) out.push({ qty: qty, label: label });
    });
    out.sort(function(a,b){ return a.qty - b.qty; });
    return out;
  }

  function withPercents(tiers){
    var max = tiers.length ? tiers[tiers.length - 1].qty : 0;
    return tiers.map(function(t){
      var p = max ? Math.min(100, (t.qty / max) * 100) : 0;
      return { qty: t.qty, label: t.label, percent: p };
    });
  }

  function progress(count, tiers){
    if (!tiers.length) return { percent: 0, reachedIndex: -1 };
    var max = tiers[tiers.length - 1].qty;
    var clamped = Math.max(0, Math.min(count, max));
    var percent = max ? (clamped / max) * 100 : 0;
    var reachedIndex = -1;
    tiers.forEach(function(t, i){ if (count >= t.qty) reachedIndex = i; });
    return { percent: Math.min(100, percent), reachedIndex: reachedIndex };
  }

  function buildDots(el, tiersP){
    var layer = el.querySelector('.kb-goal__dots');
    if (!layer) return;
    layer.innerHTML = '';
    tiersP.forEach(function(t, i){
      var dot = document.createElement('div');
      dot.className = 'kb-goal__dot';
      dot.style.left = t.percent + '%';
      dot.dataset.index = String(i);
      layer.appendChild(dot);

      var label = document.createElement('div');
      label.className = 'kb-goal__label';
      label.style.left = t.percent + '%';
      label.dataset.index = String(i);
      label.textContent = t.label;
      layer.appendChild(label);
    });
  }

  function setReached(el, reachedIndex){
    el.querySelectorAll('.kb-goal__dot').forEach(function(n){ n.classList.remove('is-reached'); });
    for (var i = 0; i <= reachedIndex; i++){
      var d = el.querySelector('.kb-goal__dot[data-index="' + i + '"]');
      if (d) d.classList.add('is-reached');
    }
  }

  function isExcludedItem(item){
    var props = item && item.properties || {};
    // KBN-Gravur-Service ist kein eigenständiges Produkt → soll nicht ins
    // Rabatt-Goal zählen. Erkennbar am _kbn_role Property das die
    // kbn-engraving.js beim Add-to-Cart auf 'addon' setzt.
    if (props._kbn_role === 'addon') return true;
    return false;
  }

  async function fetchPaidItemCount(){
    try{
      var res = await fetch('/cart.js', { headers: { 'Accept':'application/json' }});
      var cart = await res.json();
      if (!cart || !Array.isArray(cart.items)) return 0;
      return cart.items.reduce(function(sum, item){
        if (isExcludedItem(item)) return sum;
        var unitFinal = typeof item.final_price === 'number' ? item.final_price : item.price;
        return unitFinal > 0 ? sum + (item.quantity || 0) : sum;
      }, 0);
    }catch(e){
      return 0;
    }
  }

  function paint(el, tiers, count, useTransition){
    var state = progress(count, tiers);
    var fill = el.querySelector('.kb-goal__fill');
    if (fill){
      if (useTransition) fill.classList.add('has-transition');
      fill.style.width = state.percent + '%';
    }
    var bar = el.querySelector('.kb-goal__bar');
    if (bar) bar.setAttribute('aria-valuenow', String(Math.round(state.percent)));
    setReached(el, state.reachedIndex);
  }

  // ============================================================
  // Shipping-Bar Logik (amount-basiert) — data-mode="shipping"
  // ============================================================

  function buildShippingDot(el){
    var layer = el.querySelector('.kb-goal__dots');
    if (!layer) return;
    layer.innerHTML = '';
    var dot = document.createElement('div');
    dot.className = 'kb-goal__dot';
    dot.style.left = '100%';
    layer.appendChild(dot);
  }

  // Currency-aware Money-Formatter. MUSS für die aktive Currency exakt
  // matchen mit Shopify's | money Output im Liquid (cart-goal-shipping.liquid),
  // sonst greift der textContent-Idempotenz-Vergleich nicht und der
  // MutationObserver feuert beim ersten Render.
  // ISO-Code wird vom data-money-iso Attribut auf .kb-goal--shipping gelesen
  // (Liquid setzt es aus cart.currency.iso_code).
  function formatMoney(cents, iso){
    var int = Math.floor(cents / 100);
    var dec = cents % 100;
    var decStr = dec < 10 ? '0' + dec : String(dec);
    switch(iso){
      case 'CHF':
        return 'CHF ' + int + '.' + decStr;
      case 'EUR':
      default:
        return int + ',' + decStr + ' €';
    }
  }

  function paintShipping(el, amountCents, thresholdCents, useTransition){
    // ===== KRITISCH: Idempotenz-Guard gegen MutationObserver-Loop =====
    // Der Observer in renderAll() beobachtet die cart-drawer mit
    // subtree:true. Jede textContent-Änderung am Heading ist eine
    // childList-Mutation → triggert Observer → triggert renderAll →
    // ruft paintShipping erneut auf → endloser Loop + Fetch-Sturm an
    // /cart.js (= RESULT_CODE_HUNG / page hang).
    // Fix: Skip wenn der Betrag identisch zum letzten Paint ist —
    // dann gibt's keine Mutation und der Loop terminiert sofort.
    var lastAmount = el.dataset.kbLastAmount;
    if (lastAmount !== undefined && lastAmount !== '' && parseInt(lastAmount, 10) === amountCents){
      return;
    }
    el.dataset.kbLastAmount = String(amountCents);

    var pct = thresholdCents > 0
      ? Math.max(0, Math.min(100, (amountCents / thresholdCents) * 100))
      : 0;
    var reached = amountCents >= thresholdCents;

    var fill = el.querySelector('.kb-goal__fill');
    if (fill){
      if (useTransition) fill.classList.add('has-transition');
      fill.style.width = pct + '%';
    }
    var dot = el.querySelector('.kb-goal__dot');
    if (dot) dot.classList.toggle('is-reached', reached);
    var bar = el.querySelector('.kb-goal__bar');
    if (bar) bar.setAttribute('aria-valuenow', String(Math.round(pct)));

    var heading = el.querySelector('[data-shipping-heading]');
    if (heading){
      var newText;
      if (reached){
        newText = el.dataset.headingReached || 'Kostenloser Versand freigeschaltet';
      } else {
        var remaining = thresholdCents - amountCents;
        var template = el.dataset.headingUnreached || 'Noch {amount} bis zum Gratisversand';
        var iso = el.dataset.moneyIso || 'EUR';
        newText = template.replace('{amount}', formatMoney(remaining, iso));
      }
      // Double-Guard: nur updaten wenn Text wirklich anders ist
      if (heading.textContent !== newText){
        heading.textContent = newText;
      }
    }

    // Heading-Check-Visibility (hidden-Attribut, KEINE childList-Mutation
    // → MutationObserver bleibt ruhig, kein Loop-Risiko).
    var check = el.querySelector('[data-shipping-check]');
    if (check){
      if (reached) check.removeAttribute('hidden');
      else check.setAttribute('hidden', '');
    }
  }

  async function fetchCartTotal(){
    try{
      var res = await fetch('/cart.js', { headers: { 'Accept':'application/json' }});
      var cart = await res.json();
      return cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    }catch(e){
      return 0;
    }
  }

  async function renderShipping(el){
    try{
      if (!el) return;

      if (!el.dataset.kbBuilt){
        buildShippingDot(el);
        el.dataset.kbBuilt = '1';
      }

      var threshold = parseInt(el.dataset.thresholdCents || '0', 10);
      if (threshold <= 0) return;

      // Initial Paint NUR beim allerersten Render — danach observert die
      // MutationObserver evtl. Drawer-Re-Renders und ruft renderShipping
      // erneut auf; wir wollen dann direkt zum Live-Fetch springen statt
      // zwischen Server-Wert und Live-Wert hin- und herzupingpongen.
      if (!el.dataset.kbShippingInited){
        var initial = parseInt(el.dataset.initialAmountCents || '0', 10) || 0;
        paintShipping(el, initial, threshold, false);
        el.dataset.kbShippingInited = '1';

        requestAnimationFrame(function(){
          var fill = el.querySelector('.kb-goal__fill');
          if (fill) fill.classList.add('has-transition');
        });
      }

      // asynchrone Aktualisierung mit Live-Cart. Der Idempotenz-Guard in
      // paintShipping verhindert dass identische Werte wieder gerendert
      // und damit MutationObserver-Schleifen ausgelöst werden.
      var realTotal = await fetchCartTotal();
      paintShipping(el, realTotal, threshold, true);
    }catch(e){
      console.warn('KB Cart Goal (shipping) render error:', e);
    }
  }

  async function render(el){
    try{
      if (!el) return;

      // Mode-Routing: shipping (amount-based) vs default quantity-based
      if (el.dataset.mode === 'shipping') return renderShipping(el);

      // nur einmal pro Element initialisieren
      if (!el.dataset.kbBuilt){
        var tiers = readTiersFromHTML(el);
        if (!tiers.length) return;
        var tiersP = withPercents(tiers);
        buildDots(el, tiersP);
        el.dataset.kbBuilt = '1';
      }

      // sofortiger First Paint mit serverseitiger Anzahl
      var tiersNow = readTiersFromHTML(el);
      if (!tiersNow.length) return;
      var initial = parseInt(el.getAttribute('data-initial-count') || '0', 10) || 0;
      paint(el, tiersNow, initial, false);

      // Transition erst danach aktivieren
      requestAnimationFrame(function(){
        var fill = el.querySelector('.kb-goal__fill');
        if (fill) fill.classList.add('has-transition');
      });

      // asynchron mit echten bezahlten Items aktualisieren
      var paidCount = await fetchPaidItemCount();
      paint(el, tiersNow, paidCount, true);
    }catch(e){
      // Fehler abfangen, Seite bleibt stabil
      console.warn('KB Cart Goal render error:', e);
    }
  }

  function renderAll(){
    try{
      document.querySelectorAll(SEL).forEach(function(el){ render(el); });
    }catch(e){
      console.warn('KB Cart Goal renderAll error:', e);
    }
  }

  // Events
  document.addEventListener('DOMContentLoaded', renderAll);
  window.addEventListener('pageshow', renderAll);
  document.addEventListener('cart:updated', renderAll);
  document.addEventListener('ajaxProduct:added', renderAll);
  document.addEventListener('shopify:section:load', renderAll);
  document.addEventListener('shopify:section:render', renderAll);
  document.addEventListener('drawer:open', renderAll);
  document.addEventListener('drawer:opened', renderAll);

  // Fallback Observer nur auf den Drawer beschränken
  var target = document.querySelector('cart-drawer');
  if (target){
    var mo = new MutationObserver(function(){ renderAll(); });
    mo.observe(target, { childList:true, subtree:true });
  }
})();
